<template>
  <div class="container is-fluid full-viewport" >
    <div
      class="columns full-viewport is-mobile " >
      <div class="column is-6 has-text-right" >
        <img src="@/assets/images/404.svg" style="max-height: 250px !important">
      </div>
      <div class="column is-6 align-center " :class="$mq === 'mobile' || $mq === 'tablet' ? '' : 'has-text-left' " >
        <span class="has-text-weight-bold is-size-1 " style="padding-top: 12vh" >404</span>
        <span class="has-text-weight-bold" >Página No Encontrada</span>        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
